import ProfileDisbursement from './profile-disbursement';

export default ProfileDisbursement;
